import classnames from 'classnames'

import './cubby.scss'


const Cubby = props => <div {...props} className={classnames('cubby', 'flex-child', props.className)} />

export default Cubby
